<template>
	<div>
		<router-view v-show="$route.matched.length == 3"></router-view>
		<PageHeaderLayout v-show="$route.matched.length == 2">
			<div class="main-page-content" v-if="userPermissions.indexOf('labor_list') != -1">
				<el-row style="height: 36px">
					<el-form :inline="true" :model="searchCondition">
						<el-form-item label="时间">
							<DatePicker @dataSearch="dataSearch"/>
						</el-form-item>
						<el-form-item>
							<el-button @click="searchButton" style="color: #1890ff">查询</el-button>
						</el-form-item>
					</el-form>
				</el-row>
				<el-row>
				<ScreeCompany
				:allowField="allowField"
				@ScreeCompany="ScreeCompany" />
				<div class="table-right">
				<el-button :loading="downloadLoading" style="margin:0 0 20px 20px;" type="primary" size="medium" icon="el-icon-document" @click="getDownloadData('','all')" >
				导出
				</el-button>
				</div>
				</el-row>
				<el-row>
					<el-button type="primary" size="medium" @click="handleGoInvoice" class="btn_apply" >
					申请代开
					</el-button>
					<el-button type="primary" size="medium" @click="downLoadMult" >
					批量下载
					</el-button>
				</el-row>
				
				<ApeTable ref="apeTable" :data="companyList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row
				@selectList="event_selectList"
				>
				<template #first-column>
					<el-table-column type="selection" width="55" :selectable="event_selectable">
					</el-table-column>
				</template>
				<el-table-column
				width="220"
				header_align='center'
				align='center'
				label="操作">
				<template slot-scope="scope">
				<span>
				<el-button size="mini" type="primary" v-if="![2,3,4].includes(scope.row.status)" @click="waitSubmilt(scope.row.id)">提交</el-button>
				<el-button size="mini" type="default" :loading='sys.loading' v-if="scope.row.invoice_status == 4" @click="downZIP(scope.row.id)">下载</el-button>
				<el-button size="mini" type="primary" plain @click="viewApplyDetails(scope.row.id)">申请详情</el-button>
				<el-button size="mini" type="primary" v-if="scope.row.status!=4"  @click="getDownloadData(scope.row,'detail')">导出</el-button>
				<el-popover
				placement="top"
				width="150"
				v-model="scope.row.visible">
				<p>确定要删除记录吗？</p>
				<div style="text-align: right; margin: 0;">
				<el-button type="text" size="mini" @click="scope.row.visible=false">取消</el-button>
				<el-button type="danger" size="mini" @click="deleteButton(scope.row.id)">确定</el-button>
				</div>
				</el-popover>
				</span>
				</template>
				</el-table-column>
				</ApeTable>
			</div>
		</PageHeaderLayout>
	</div>

</template>

<script>
	import PageHeaderLayout from '@/layouts/PageHeaderLayout'
	import DatePicker from '@/components/DatePicker.vue'
	import ScreeCompany from '@/components/ScreeCompany.vue'
	import MonthPicker from '@/components/MonthPicker.vue'
	import ApeTable from '@/components/ApeTable'
	import {downloadFileUrl} from '@/utils/utils.js'
	import { mapGetters } from 'vuex'
	export default {
		components: {
		PageHeaderLayout,
		DatePicker,
		ScreeCompany,
		MonthPicker,
		ApeTable
		},
		data() {
			return {
					selectTarVoiceArr:[],
					sys:{
						loading:false,
					},
					columns: [
						{
						title: '编号',
						value: 'id',
						width: 170,
						header_align: 'center',
						align: 'center',
						},
						{
						title: '开票类型',
						width: 200,
						header_align: 'center',
						align: 'center',
						value: 'invoice_type_text'
						},
						{
						title: '申请开票时间',
						value: 'created_at',
						header_align: 'center',
						align: 'center',
						},
						{
						title: '申请开票金额',
						value: 'invoice_money',
						header_align: 'center',
						align: 'center',
						},
						{
						title: '征收类目',
						value: 'zs_type',
						header_align: 'center',
						align: 'center',
						},
						{
						title: '项目名称',
						value: 'project_name',
						header_align: 'center',
						align: 'center',
						},
						{
						title: '客户名称',
						value: 'company_name',
						header_align: 'center',
						align: 'center',
						},
						{
						title: '开票公司',
						value: 'channel_name',
						header_align: 'center',
						align: 'center',
						},
						{
						title: '开票状态',
						value: 'alias_status',
						header_align: 'center',
						align: 'center',
						},
						{
						title: '驳回原因',
						value: 'remark',
						header_align: 'center',
						align: 'center',
						/*  width: 180 */
						}
					],
					loadingStaus: true,
					searchCondition:{},
					allowField: ['companyId', 'settlementId'],
					downloadLoading: false,
					// 表格列表数据
					companyList:[],
					// 分页信息
					pagingData:{
						is_show: true,
						layout: 'total, sizes, prev, pager, next, jumper',
						total: 0
					}
				}
			},
		methods:{
			// 格式化状态
			getStatus(value){
			let text = ''
			// 状态0－未审核，1－初审通过，-1－初审未通过，2 - 复审通过，-2-复审未通过，3-支付成功，-3-支付失败，4-待开票，-4-提交开票失败，5-开票成功，-5-开票失败，-6-失效，-10-删除
			switch (value) {
			case 0:
			text = '未审核'
			break;
			case 1:
			text = '初审通过'
			break;
				case -1:
			text = '初审未通过'
			break;
			case 2:
			text = '复审通过'
			break;
			case -2:
			text = '复审未通过'
			break;
			case 3:
			text = '支付成功'
			break;
			case -3:
			text = '支付失败'
			break;
			case 4:
			text = '待开票'
			break;
			case -4:
			text = '提交开票失败'
			break;
			case 5:
			text = '开票成功'
			break;
			case -5:
			text = '开票失败'
			break;
			case -6:
			text = '失效'
			break;
			case -10:
			text = '删除'
			break;
			}
			return text
			},
		async	getDownloadData(row,type){
			let resData=[]
				if(type==='detail'){
					const {data} = await this.$api.invoiceManageOrderList({
					invoice_id:row.id,
					current_page: 1,
					page_size: 100000000
					})
					resData=data
				}else if(type==='all'){
					this.downloadLoading = true
					let searchCondition = this.handleSearchCondition()
					
					const {data} = await this.$api.getLaowuInvoicEexport({
					current_page: 1,
					page_size: 100000000,...searchCondition
					})
					this.downloadLoading = false
					resData=data
				}
				if(!resData.length){
					this.$message.warning("暂无数据");
					return
				}
				
				//console.log(resData)
				this.downLoadDetail(resData)
			},
			downLoadDetail(row){
				import('@/excel/Export2Excel').then( excel => {
				const tHeader = ['姓名','身份证号','付款方名称','付款方税号','金额','发票种类','状态', '征收品目', '项目名称', '增值税','个人所得税','教育费附加税','地方教育费附加税', '教育费附加税补收', '地方教育费附加税补收',  '城市维护建设税', '地方水利建设基金', '印花税', '资源税','税额合计', '单据编号', ];
				const list=row.map(v =>{
			let {
			user,
			id_number,
			company_name,
			company_no,
			money,
			invoice_type,
			status,
			bm_json,
			project_name,
			result_json_data
			
			} = v
			const {zzs,grsds,jyffjs,dfjyffjs,jyffjsbs,dfjyffjsbs,cswhjss,dfsljsjj,yhs,zys,sehj,djbh,}=result_json_data
			return [ user?.full_name||'',id_number,company_name,company_no,money,invoice_type,this.getStatus(status),bm_json?JSON.parse(bm_json).type_name:'' ,project_name,zzs,grsds,jyffjs,dfjyffjs,jyffjsbs,dfjyffjsbs,cswhjss,dfsljsjj,yhs,zys,sehj,djbh]
			})
				const data = list
				const time = new Date().getTime() + Math.random() * 1000
				let filename = `申请明细${time}`
				excel.export_json_to_excel({
				header: tHeader, //Header Required
				data, //Specific data Required
				filename: filename, //Optional
				autoWidth: true, //Optional
				bookType: this.bookType //Optional
				})
				})
			},
			// 多选项
			event_selectList(e){
				this.selectTarVoiceArr = e
			},
			// 是否禁用
			event_selectable(row){
				if(row.invoice_status == 4){
					return true
				}
			},
			// 批量下载
			downLoadMult(){
				if(this.selectTarVoiceArr.length == 0){
					this.$message.warning("请选择一项");
					return false
				}else{
					// this.selectTarVoiceArr.map(item=>{
					// 	this.downZIP(item.id)
					// })
					this.downZIP('',1)
				}
			},
			async downZIP(e,index){
				let tar_index=index
				console.log(this.selectTarVoiceArr,tar_index)
				if(tar_index){
					this.sys.loading=true
					let result = await this.$api.laowuDownload({id:this.selectTarVoiceArr[tar_index-1].id})
					this.sys.loading=false
					if(!result){
					return	this.$message.warning("正在生成中 ,稍后再试");
					}
					downloadFileUrl(result,'发票')
					
					if(tar_index<this.selectTarVoiceArr.length){
						tar_index++
						this.downZIP('',tar_index)
					}
					return false
				}
				this.sys.loading=true
				let result = await this.$api.laowuDownload({id:e})
				this.sys.loading=false
				if(!result){
					return this.$message.warning("正在生成中 ,稍后再试");
				}
				downloadFileUrl(result,'发票')
			},
			// 提交
			async waitSubmilt(id){
				await this.$api.laowuSubmilt({id})
				this.init()
			},
			//查看申请详情
			viewApplyDetails(id) {
			this.$router.push({path:'/laowu/detail', query: {id: id, title: '在线开票',isLaowuCompany:true}})
			},
			// 申请开票
			handleGoInvoice(){
				this.$router.push({ path: "/laowu/apply", query: { save: "save",isLaowuCompany:1 } });
			},
			//导出
			async handleDownload() {
			this.isExport = true;
			this.downloadLoading = true
			let list = await this.init('export')
			import('@/excel/Export2Excel').then( excel => {
			const tHeader = ['编号','开票类型','申请开票时间','申请开票金额','征收类目','项目名称','客户名称', '开票公司', '开票状态', '驳回原因'];
			const data = this.formatJson(list)
			const time = new Date().getTime() + Math.random() * 1000
			let filename = `劳务代开${time}`
			excel.export_json_to_excel({
			header: tHeader, //Header Required
			data, //Specific data Required
			filename: filename, //Optional
			autoWidth: true, //Optional
			bookType: this.bookType //Optional
			})
			this.downloadLoading = false;
			})
			},
			//转换导出数据
			formatJson(jsonData) {
			return jsonData.map(v =>{
			let {
			id,
			invoice_type_text,
			invoice_money,
			zs_type,
			project_name,
			company_name,
			channel_name,
			remark,
			created_at,
			alias_status
			} = v
			return [ id,invoice_type_text,created_at,invoice_money,zs_type,project_name,company_name,channel_name,alias_status,remark]
			})
			},
			ScreeCompany(v, name) {
			if(name == 'company') {
			if (v) {
			this.searchCondition.company_id = v
			} else {
			delete this.searchCondition.company_id
			}
			this.init('search')
			}
			if(name == 'settlement') {
			if (v) {
			this.searchCondition.channel_account = v
			} else {
			delete this.searchCondition.channel_account
			}
			this.init('search')
			}
			},
			// 切换页码操作
			async switchPaging() {
				this.init()
			},
			// 搜索
			searchButton() {
				this.init('search')
			},
			//获取选中日期的值
			dataSearch(value) {
			if(value === null || value[0] == ''){
				delete this.searchCondition.start_time
				delete this.searchCondition.end_time
				return false
			}
			this.searchCondition.start_time = value[0]
			this.searchCondition.end_time = value[1]
			},
			replaceStr(str) {
				const middleValue = str.substring(4,14)
				return str = `****${middleValue}****`
			},
			// 处理搜索条件
			handleSearchCondition() {
			let condition = {}
			if (this.searchCondition.fullname) {
			condition.fullname = this.searchCondition.fullname
			}
			if (this.searchCondition.sign_type) {
			condition.sign_type = this.searchCondition.sign_type
			}
			if (this.searchCondition.start_time) {
			condition.start_time = this.searchCondition.start_time
			}
			if (this.searchCondition.end_time) {
			condition.end_time = this.searchCondition.end_time
			}
			if (this.searchCondition.company_id) {
			condition.company_id = this.searchCondition.company_id
			}
			if (this.searchCondition.channel_account) {
			condition.channel_account = this.searchCondition.channel_account
			}
			return condition
			},
			// 初始化列表
			async init(type) {
				let pagingInfo = this.$refs['apeTable']?.getPagingInfo(type) || {current_page:1,page_size:10}
				if (type == 'export') {
				pagingInfo.page_size = 50000
				console.log(pagingInfo,'页面对象')
				} else {
				this.loadingStaus=true
				}
				if(type == 'search') {
				pagingInfo.current_page = 1
				}
				let searchCondition = this.handleSearchCondition()
				Object.assign(searchCondition,pagingInfo)
				let {list, pages} = await this.$api.getLaowuInvoiceList(searchCondition)
				list.map(item=>{
					if(item.invoice_status == 0){
						item.invoice_status_text = '无状态'
					}
					if(item.invoice_status == 1){
						item.invoice_status_text = '开票中'
					}
					if(item.invoice_status == 2){
						item.invoice_status_text = '复核中'
					}
					if(item.invoice_status == 3){
						item.invoice_status_text = '复核通过'
					}
					if(item.invoice_status == 4){
						item.invoice_status_text = '发票寄出'
					}
					if(item.invoice_status == 5){
						item.invoice_status_text = '复核失败'
					}
					item.zs_type = item.mb_arr.name
					
					if(item.invoice_type == 1){
						item.invoice_type_text = '增值税专用发票'
					}else{
						item.invoice_type_text = '普通发票'
					}
				})
				if (type == 'export') {
				return list
				} else {
				this.companyList = []
				this.$nextTick(() => {
				this.companyList=list
				})
				this.pagingData.total = pages.total
				console.log(this.pagingData.total,'总数')
				this.offset = pages.offset
				this.loadingStaus=false
				}
			}
		},
		computed: {
		...mapGetters(['userPermissions','buttonType'])
		},
		watch: {
			'$route':'init'
		},
		mounted() {
			this.init()
		}
	}
</script>

<style lang="scss" scoped>
	.table-right{
		float: right;
	}
	.btn_apply{
		margin-right: 30px;
	}
</style>